module.exports = __webpack_public_path__ + "img/14_4.c513dfc8.png";